import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar: React.FC = () => {
  return (
    <nav>
      <div className="nav-content">
        <Link to="/" className="logo">
          <img 
            src="/icons/logo.svg" 
            alt="AssistantsLab Logo" 
          />
        </Link>
        <div className="nav-links">
          <Link to="/research">Research</Link>
          <Link to="/products">Products</Link>
          <Link to="/about">About</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;